import {
  CREATE_QR_DESIGN_REQUEST,
  CREATE_QR_DESIGN_SUCCESS,
  CREATE_QR_DESIGN_FAIL,
  GET_QR_DESIGNS_REQUEST,
  GET_QR_DESIGNS_SUCCESS,
  GET_QR_DESIGNS_FAIL,
} from "../actionTypes";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";

export const createQrDesign = (qrDesignData, token) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_QR_DESIGN_REQUEST });
    const response = await axiosInstance.post("/api/create-qr-design-format/", qrDesignData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    console.log("Create QR Design response:", response.data);
    dispatch({ type: CREATE_QR_DESIGN_SUCCESS, payload: response.data });
    toast.success(response.data.message || "QR Design created successfully");
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to create QR Design";
    dispatch({
      type: CREATE_QR_DESIGN_FAIL,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    console.log("Create QR Design error:", error.response?.data || error.message);
    throw error;
  }
};

export const getQrDesigns = (filters = {}, token) => async (dispatch) => {
  try {
    dispatch({ type: GET_QR_DESIGNS_REQUEST });
    const queryParams = new URLSearchParams();
    
    if (filters.client_id) queryParams.append("client_id", filters.client_id);
    if (filters.is_active !== undefined) queryParams.append("is_active", filters.is_active);
    if (filters.created_by) queryParams.append("created_by", filters.created_by);
    
    const url = `/api/qr-design-formats/${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Get QR Designs response:", response.data);
    dispatch({ type: GET_QR_DESIGNS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to fetch QR Designs";
    dispatch({
      type: GET_QR_DESIGNS_FAIL,
      payload: errorMessage,
    });
    console.log("Get QR Designs error:", error.response?.data || error.message);
    return { qr_designs: [], count: 0, error: errorMessage };
  }
};

